export const ACCESS_TOKEN = "ultra-court-booking-access-token";
export const REQUEST_PLAYER_DATES_LIST_COUNT = 6;
export const IS_HIDE_TOP_BAR = "ultra-court-booking-is-hide-top-bar";
export const TOTAL_PLAYERS_TO_SELECT = 3;
export const MOBILE_SCREEN_WIDTH = 768;
export const TOTAL_SCORE_SETS = 3;
